import { createSlice } from "@reduxjs/toolkit";
import VwServisprotokol1DTO from "src/models/GenelTanimlar/VwServisprotokol1DTO";
import VwServisprotokol2DTO from "src/models/GenelTanimlar/VwServisprotokol2DTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";


export interface IServisProtokol {
    servisProtokol1ActiveRow: VwServisprotokol1DTO;
    servisProtokol2ActiveRow: VwServisprotokol2DTO;
    servisProtokol1Kod: number;
}

const ServisProtokolSlice = createSlice<IServisProtokol, MapReducerPayloads<IServisProtokol, {
    setServisProtokol1ActiveRow: VwServisprotokol1DTO;
    setServisProtokol2ActiveRow: VwServisprotokol2DTO;
    setServisProtokol1Kod: number;
}>>({
    name: 'ServisProtokolState',
    initialState: {
        servisProtokol1ActiveRow: new VwServisprotokol1DTO(),
        servisProtokol2ActiveRow: new VwServisprotokol2DTO(),
        servisProtokol1Kod: null
    },
    reducers: {
        setServisProtokol1ActiveRow: (state, action) => {
            state.servisProtokol1ActiveRow = action.payload;
        },
        setServisProtokol2ActiveRow: (state, action) => {
            state.servisProtokol2ActiveRow = action.payload;
        },
        setServisProtokol1Kod: (state, action) => {
            state.servisProtokol1Kod = action.payload;
        }
    }
})
export default ServisProtokolSlice;